import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, WritableSignal, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable, of, Subject } from 'rxjs';
import { Incident, IncidentsService, ViewIncident } from 'src/app/api/incidents.service';
import { WorkflowPriority, WorkflowService } from 'src/app/api/workflow.service';
import { SplitButton } from 'primeng/splitbutton';

@Component({
  selector: 'app-priority-button',
  templateUrl: './priority-button.component.html',
  styleUrls: ['./priority-button.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriorityButtonComponent implements OnInit {

  menuItems: WritableSignal<MenuItem[]> = signal<MenuItem[]>([])
  private _incident: ViewIncident
  @Input() set incident(value: ViewIncident) {
    this._incident = value
    this.priorities$ = this.workflowService.getPrioritiesForWorkflow(value.workflowId)
    this.currentPriorityName$ = this.workflowService.getPriorityName(value.priorityId);
  }

  get incident(): ViewIncident {
    return this._incident
  }
  priorities$: Observable<WorkflowPriority[]> = of([])
  currentPriorityName$: Observable<string> = of("");

  @Input()
  size: SplitButton["size"] = undefined;

  @Output()
  updateComplete = new EventEmitter<ViewIncident>();

  constructor(
    private workflowService: WorkflowService,
    private incidentService: IncidentsService
  ) {
    this._incident = this.incidentService.emptyViewIncident;
  }


  ngOnInit(): void {
    this.priorities$.subscribe(priorities => {
      priorities.forEach(priority => {
        this.menuItems.update(value => [...value, {
          label: priority.name,
          command: () => { this.onPriorityClick(priority) }
        }])
      })
    })
  }


  onPriorityClick(priority: WorkflowPriority) {
    this.incidentService.updateIncident(this.incident.workItemId, { priorityId: priority.workflowPriorityId }).subscribe(() => {
      this.incidentService.getIncident(this.incident.workItemId).subscribe(incident => {
        this.incident = incident;
        this.updateComplete.emit(incident);
      });
    })
  }

}
